import { createActionGroup, createFeature, createReducer, on, props } from '@ngrx/store';

import { Delta } from 'quill';

import { QuillTemplate, QuillTemplateLocation } from '../../../generated/graphql.generated';

export const TEMPLATES_WITH_SUBJECT = new Set([
    QuillTemplateLocation.JobCommentSendEmailToCustomer,
    QuillTemplateLocation.DispatchSchedule,
]);

export const TemplatesActions = createActionGroup({
  source: 'Templates',
  events: {
    'Create Template Button Clicked': props<{ location: QuillTemplateLocation }>(),
    'Edit Template Button Clicked': props<{ template: QuillTemplate }>(),

    'Template Creation Requested': props<{ input: { name: string; contents: string; subjectContents: string;
        location: QuillTemplateLocation } }>(),
    'Template Created': props<{ template: QuillTemplate }>(),
    'Template Creation Failed': props<{ error: Error }>(),

    'Template Update Requested': props<{ input: { ids: string[];
        update: { name?: string; contents?: string; subjectContents?: string; location: QuillTemplateLocation; isDefault?: boolean} } }>(),
    'Template Updated': props<{ template: QuillTemplate }>(),
    'Template Update Failed': props<{ error: Error }>(),

    'Template Deletion Requested': props<{ id: string }>(),
    'Template Deleted': props<{ id: string }>(),
    'Template Deletion Failed': props<{ error: Error }>(),

    // Inline table editing actions
    'Template Content Edited': props<{ templateId: string; contents?: Delta; subjectContents?: Delta }>(),
    'Discard Button Clicked': props<{template: QuillTemplate}>(),
    'Save Button Clicked': props<{template: QuillTemplate}>(),
  }
});

const templatesInitialState = {
    templateContentEdits: {} as Record<string, {
        contents: Delta;
        subjectContents: Delta | null;
    }>,
};

export type TemplatesState = typeof templatesInitialState;

export const templatesFeature = createFeature({
	name: 'Templates',
	reducer: createReducer(
		templatesInitialState,
		on(TemplatesActions.templateContentEdited, (state, { contents, templateId, subjectContents }): TemplatesState => {
            if (!templateId || (!contents && !subjectContents)) {
                return state;
            }

            const updatedTemplateSpecificContent = {
                ...(state.templateContentEdits[templateId] || {}),
                ...(contents && { contents }),
                ...(subjectContents && { subjectContents })
            };

            return {
                ...state,
                templateContentEdits: {
                    ...state.templateContentEdits,
                    [templateId]: updatedTemplateSpecificContent
                },
            };
        }),
        on(TemplatesActions.discardButtonClicked, (state): TemplatesState => {
            return {
                ...state,
                templateContentEdits: {}
            };
        }),
        on(TemplatesActions.templateUpdated, (state, { template: updatedTemplate }): TemplatesState => {
            const newTemplateContentEdits = { ...state.templateContentEdits };

            // Delete the property from the new copy
            delete newTemplateContentEdits[updatedTemplate.id];

            return {
                ...state,
                templateContentEdits: newTemplateContentEdits,
            };
        })
	)
});
